var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jsycDetail"},[_c('ld-header',{attrs:{"transparent":"","white":"","z-index":99999},on:{"click-left":_vm.back}},[_c('img',{staticClass:"custom-back",attrs:{"slot":"left","src":require("Assets/images/back.png")},slot:"left"})]),_c('detail',{ref:"detail",attrs:{"order-id":this.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }